import React, { useEffect, useState } from "react";
import {
  createComponentStore,
  useStoreState,
  useStoreActions,
} from "easy-peasy";
import { PageHeader, Button, Spin, Tabs } from "antd";
import UserStoreModel, { ACTION_TYPES } from "store/models/user";
import { useParams, useRouteMatch, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UserGroupUsersRoute from "./view/users";
import UserGroupAuthsRoute from "./view/authorizations";
import { RULES } from "Constants/rules";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import FourOThree from "Pages/private/403";
import FourOFour from "Pages/private/404";

const { TabPane } = Tabs;
const useUserStore = createComponentStore(UserStoreModel);

export default function UserGroupDetailPage({ ...props }) {
  const { abilities } = useStoreState((store) => store.auth);
  const IsAuthorized = AuthCheck(
    abilities,
    AUTH_ACTIONS.READ,
    "Kullanıcı Listesi"
  );

  const { updateBreadcrumb } = useStoreActions((store) => store.app);

  const [store, actions] = useUserStore();
  const [userGroup, setUserGroup] = useState(null);

  const isEditable = (record) => {
    return ![RULES.RULE0019, RULES.RULE0020].includes(record?.rule?.code);
  };

  let { id } = useParams();
  let history = useHistory();
  let match = useRouteMatch();

  const IsLoading = (process) => {
    return [ACTION_TYPES.FETCHING_USER_GROUPS].includes(process);
  };

  useEffect(() => {
    if (IsAuthorized) actions.getUserGroups();
  }, [id]);

  useEffect(() => {
    if (store.userGroups.length > 0) {
      setUserGroup(store.userGroups.find((f) => f.id == id));
    }
  }, [store.userGroups]);

  useEffect(() => {
    if (userGroup)
      updateBreadcrumb({
        object: { name: userGroup.name, path: match.path },
        index: 1,
      });
  }, [userGroup]);

  return (
    <>
      <Spin spinning={IsLoading(store.process)}>
        <PageHeader
          backIcon={<FontAwesomeIcon icon={["fas", "chevron-left"]} />}
          onBack={() => {
            let pathArr = match.path.split("/");
            pathArr.pop();
            history.push(pathArr.join("/"));
          }}
          title={userGroup?.name}
        />
        {IsAuthorized ? (
          userGroup ? (
            <Tabs
              defaultActiveKey="1"
              style={{ padding: "0 24px", overflow: "unset" }}
            >
              <TabPane tab="Yetkiler" key="1">
                <UserGroupAuthsRoute id={id} editable={isEditable(userGroup)} />
              </TabPane>
              <TabPane tab="Kullanıcılar" key="2">
                <UserGroupUsersRoute id={id} />
              </TabPane>
            </Tabs>
          ) : (
            <FourOFour />
          )
        ) : (
          <FourOThree />
        )}
      </Spin>
    </>
  );
}
